<template lang="">
  <router-view></router-view>
</template>

<script>
export default {

  name: 'ConfirmacionProcesosM',
  data () {
    return {
    }
  }
  
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/cpmensual/cp-mensual.vue